// @ts-nocheck
import { Column } from 'react-table';
import { PostTagDto } from '../model/types';
import { LucideIconCell } from './LucideIconCell';
import { TagCustomCell } from './TagCustomCell';
import { TagCustomHeader } from './TagCustomHeader';

const getLang = (obj: Record<string, string> | undefined, lang: string): string => {
	if (!obj) return '';
	return obj[lang] || obj['ru'] || Object.values(obj)[0] || '';
};

const tagsColumns = (lang: string): ReadonlyArray<Column<PostTagDto>> => [
	{
		Header: props => (
			<TagCustomHeader tableProps={props} title='Тег' className='min-w-125px' />
		),
		id: 'uuid',
		Cell: ({ ...props }) => (
			<TagCustomCell value={props.data[props.row.index]?.uuid} />
		),
	},

	{
		Header: props => (
			<TagCustomHeader tableProps={props} title='Имя' className='min-w-100px' />
		),
		id: 'name',
		Cell: ({ ...props }) => (
			<TagCustomCell value={getLang(props.data[props.row.index]?.name, lang)} />
		),
	},

	{
		Header: props => (
			<TagCustomHeader
				tableProps={props}
				title='Иконка'
				className='min-w-100px'
			/>
		),
		id: 'icon',
		Cell: ({ ...props }) => (
			<LucideIconCell name={props.data[props.row.index]?.icon} />
		),
	}
];

export { tagsColumns };
